import Image from 'next/image';
import React, { useState } from 'react';
import { carretDown } from '../../../public/assets/icons';
import styles from './select.module.scss';
import { closeModal } from '../../../assets/icons';

const MultiSelect = ({
  options,
  selected,
  setSelected,
  error,
  value,
  setValue,
}) => {
  const [errorMessage, setErrorMessage] = useState(false);
  const [active, setActive] = useState(false);

  const addItem = val => {
    value.includes(val)
      ? setErrorMessage(true)
      : setValue([...value, val]) & setErrorMessage(false);
  };

  return (
    <>
      {errorMessage && (
        <p className="text-xs text-red-500 font-semibold text-center">
          {' '}
          You have already picked this option{' '}
        </p>
      )}
      <section
        className={[
          styles.dropdown,
          `${error ? ' bg-error-light' : 'bg-light-input'}`,
        ].join(' ')}
      >
        <div
          className={styles.dropdown_btn}
          onClick={() => setActive(prev => !prev)}
        >
          <div className="relative h-full w-full ">
            <div className="flex absolute">
              {value?.map((item, idx) => (
                <button
                  key={idx}
                  className="text-base bg-[#FFF] rounded-full px-3 py-1 m-2 flex items-center"
                >
                  <span className="w-max"> {item} </span>
                  <span
                    className="ml-2 flex items-center w-max"
                    onClick={() =>
                      setValue(
                        selected.filter(item => selected.indexOf(item) !== idx)
                      )
                    }
                  >
                    <i className="material-icons text-red-400 text-[16px]">
                      close
                    </i>
                  </span>
                </button>
              )) || <span className="text-neutral-mid-60">Select...</span>}
            </div>
          </div>
          <div
            className={`${
              active ? 'rotate-180' : null
            } transition-all duration-200 ease-linear`}
          >
            <Image src={carretDown} alt="carret down" />
          </div>
        </div>
        {active && (
          <div className={styles.dropdown_content}>
            {options.length === 0 ? <h2>No Items to Display</h2> : null}
            {options &&
              options.map((option, idx) => (
                <div
                  className={styles.dropdown_item}
                  key={idx}
                  onClick={e => {
                    addItem(option.value);
                    setActive(false);
                  }}
                >
                  {option.label}
                </div>
              ))}
          </div>
        )}
      </section>
    </>
  );
};

export default MultiSelect;
